import PaymentOptions from '../../../defaultFlow/tabs/payment/paymentOptions.js'
import {
  PaymentGatewayFull,
  PaymentGatewayDeposit,
  FakePaymentGatewayFull,
  FakePaymentGatewayDeposit,
} from '../../../defaultFlow/tabs/payment/options/index.js'

export default class PaymentOptionsDayTour extends PaymentOptions {
  constructor (options) {
    super(options)
  }

  setupAvailablePaymentOptions () {
    if (this.paymentTab.features.paymentGatewayEnabled) {
      if (this.config.environment === 'test') {
        this.availablePaymentOptions = [
          new FakePaymentGatewayFull(this.paymentTab),
          new FakePaymentGatewayDeposit(this.paymentTab),
        ]
      } else {
        this.availablePaymentOptions = [
          new PaymentGatewayDeposit(this.paymentTab),
          new PaymentGatewayFull(this.paymentTab),
        ]
      }
    }
  }
}
